import { Component } from 'preact'
import { connect } from 'preact-redux'

import expandScreenToFlags from '../expandScreenToFlags'

import NewPaybarPayer from '../newPaybarPayer'
import NewPaybarPersonalForm from '../newPaybarPersonalForm'
import NewPaybarOverlay from '../newPaybarOverlay'
import NewPaybarTitle from '../newPaybarTitle'
import NewPaybarTabs from '../newPaybarTabs'
import NewPaybarPricingVacancy from './newPaybarPricing'
import NewPaybarSubscriptionStatus from '../newPaybarSubscriptionStatus'
import NewPaybarVacancyPublicationsStatus from './newPaybarVacancyPublicationsStatus'

class NewPaybarBurosferaVacancy extends Component {
  get shouldDisplaySubscriptionStatus() {
    const isSubscriptionScreen = this.props.isSubscriptionScreen
    const isSuccessScreen = this.props.isSuccessScreen
    const isSelf = this.props.type === 'self'

    return isSelf && (isSubscriptionScreen || isSuccessScreen)
  }

  render(props) {
    const shouldDisplayPricing = props.isPurchaseScreen || props.isInitialScreen

    return (
      <div className="newPaybar-infoIn module">
        { !props.isSuccessScreen &&
          <NewPaybarTabs device="mobile" type={ props.type } product={ props.product } />
        }

        <NewPaybarTitle
          className="newPaybarTitle newPaybarBurosferaVacancyTitle module device device__mobile"
          type={ props.type }
          screen={ props.screen }
          product={ props.product }
          productTitle={ props.productTitle } />

        { props.isSuccessScreen &&
          <NewPaybarOverlay className="device device__mobile" />
        }

        <div className="newPaybarBurosferaVacancyPricingAndInfo">
          { shouldDisplayPricing &&
            <NewPaybarPricingVacancy type={ props.type } prices={ props.prices } />
          }

          { (props.isSuccessScreen || props.isSubscriptionScreen) &&
            <NewPaybarVacancyPublicationsStatus subscription={ props.subscription } />
          }
        </div>

        { props.isPurchaseScreen &&
          <NewPaybarPayer payerRef={ props.payerRef } isCompact />
        }

        { this.shouldDisplaySubscriptionStatus &&
          <NewPaybarSubscriptionStatus className="device device__laptop device__desktop" />
        }

        { !props.isSuccessScreen &&
          <NewPaybarPersonalForm
            subscriptionUrl={ props.subscriptionUrl }
            scrollableRef={ props.scrollableRef } />
        }

        { this.props.children }
      </div>
    )
  }
}

const mapStateToProps = ({ newPaybar }) => {
  return {
    type: newPaybar.type,
    product: newPaybar.product,
    productTitle: newPaybar.productTitle,
    prices: newPaybar.prices,
    screen: newPaybar.screen,
    subscription: newPaybar.subscription,
    ...expandScreenToFlags(newPaybar.screen),
  }
}

export default connect(mapStateToProps)(NewPaybarBurosferaVacancy)
